import {
  CREATE_ACCOUNT_BANK,
  CREATE_ACCOUNT_BANK_FAIL,
  CREATE_ACCOUNT_BANK_SUCCESS,
  CREATE_CUSTOMER_INVOICE,
  CREATE_CUSTOMER_INVOICE_FAIL,
  CREATE_CUSTOMER_INVOICE_SUCCESS,
  DELETE_CUSTOMER_INVOICE,
  DELETE_CUSTOMER_INVOICE_FAIL,
  DELETE_CUSTOMER_INVOICE_SUCCESS,
  EDIT_CUSTOMER_INVOICE,
  EDIT_CUSTOMER_INVOICE_FAIL,
  EDIT_CUSTOMER_INVOICE_SUCCESS,
  GET_ALL_ACCOUNT_BANK,
  GET_ALL_ACCOUNT_BANK_FAIL,
  GET_ALL_ACCOUNT_BANK_SUCCESS,
  GET_ALL_CUSTOMER_INVOICE,
  GET_ALL_CUSTOMER_INVOICE_FAIL,
  GET_ALL_CUSTOMER_INVOICE_SUCCESS,
  GET_DETAIL_CUSTOMER_INVOICE,
  GET_DETAIL_CUSTOMER_INVOICE_FAIL,
  GET_DETAIL_CUSTOMER_INVOICE_SUCCESS,
  GET_LIST_CUSTOMER_INVOICE,
  GET_LIST_CUSTOMER_INVOICE_FAIL,
  GET_LIST_CUSTOMER_INVOICE_SUCCESS,
  RESET_CREATE_ACCOUNT_BANK,
  RESET_CREATE_CUSTOMER_INVOICE,
  RESET_DELETE_CUSTOMER_INVOICE,
  RESET_EDIT_CUSTOMER_INVOICE,
  RESET_GET_ALL_ACCOUNT_BANK,
  RESET_GET_ALL_CUSTOMER_INVOICE,
  RESET_LIST_CUSTOMER_INVOICE,
  SET_COLUMN_VISIBLE_CUSTOMER_INVOICE,
} from "./actionTypes";

// Khách hàng
export const getListCustomerInvoice = params => ({
  type: GET_LIST_CUSTOMER_INVOICE,
  params,
});

export const getListCustomerInvoiceSuccess = (listData, totalCount) => ({
  type: GET_LIST_CUSTOMER_INVOICE_SUCCESS,
  listData,
  totalCount,
});

export const getListCustomerInvoiceFail = error => ({
  type: GET_LIST_CUSTOMER_INVOICE_FAIL,
  error,
});

export const resetListCustomerInvoice = error => ({
  type: RESET_LIST_CUSTOMER_INVOICE,
});

// Chi tiết Khách hàng
export const getDetailCustomerInvoice = id => ({
  type: GET_DETAIL_CUSTOMER_INVOICE,
  id,
});

export const getDetailCustomerInvoiceSuccess = data => ({
  type: GET_DETAIL_CUSTOMER_INVOICE_SUCCESS,
  data,
});

export const getDetailCustomerInvoiceFail = error => ({
  type: GET_DETAIL_CUSTOMER_INVOICE_FAIL,
  error,
});

// Tạo Khách hàng
export const createCustomerInvoice = data => ({
  type: CREATE_CUSTOMER_INVOICE,
  data,
});

export const createCustomerInvoiceSuccess = data => ({
  type: CREATE_CUSTOMER_INVOICE_SUCCESS,
  data,
});

export const createCustomerInvoiceFail = error => ({
  type: CREATE_CUSTOMER_INVOICE_FAIL,
  error,
});
export const resetCreateCustomerInvoice = error => ({
  type: RESET_CREATE_CUSTOMER_INVOICE,
});

// EDIT Khách hàng
export const editCustomerInvoice = (data, id) => ({
  type: EDIT_CUSTOMER_INVOICE,
  data,
  id,
});

export const editCustomerInvoiceSuccess = data => ({
  type: EDIT_CUSTOMER_INVOICE_SUCCESS,
  data,
});

export const editCustomerInvoiceFail = error => ({
  type: EDIT_CUSTOMER_INVOICE_FAIL,
  error,
});
export const resetEditCustomerInvoice = error => ({
  type: RESET_EDIT_CUSTOMER_INVOICE,
});

// Delete Khách hàng
export const deleteCustomerInvoice = id => ({
  type: DELETE_CUSTOMER_INVOICE,
  id,
});

export const deleteCustomerInvoiceSuccess = data => ({
  type: DELETE_CUSTOMER_INVOICE_SUCCESS,
  data,
});

export const deleteCustomerInvoiceFail = error => ({
  type: DELETE_CUSTOMER_INVOICE_FAIL,
  error,
});

export const resetDeleteCustomerInvoice = error => ({
  type: RESET_DELETE_CUSTOMER_INVOICE,
});

// getAllCustomerInvoice
export const getAllCustomerInvoice = type_id => ({
  type: GET_ALL_CUSTOMER_INVOICE,
  type_id,
});

export const getAllCustomerInvoiceSuccess = data => ({
  type: GET_ALL_CUSTOMER_INVOICE_SUCCESS,
  data,
});

export const getAllCustomerInvoiceFail = error => ({
  type: GET_ALL_CUSTOMER_INVOICE_FAIL,
  error,
});

export const resetGetAllCustomerInvoice = error => ({
  type: RESET_GET_ALL_CUSTOMER_INVOICE,
});

// getAllAccountBank
export const getAllAccountBank = () => ({
  type: GET_ALL_ACCOUNT_BANK,
});

export const getAllAccountBankSuccess = data => ({
  type: GET_ALL_ACCOUNT_BANK_SUCCESS,
  data,
});

export const getAllAccountBankFail = error => ({
  type: GET_ALL_ACCOUNT_BANK_FAIL,
  error,
});

export const resetGetAllAccountBank = error => ({
  type: RESET_GET_ALL_ACCOUNT_BANK,
});

// show/hide column
export const setColumnVisibleCustomerInvoice = (field, value) => ({
  type: SET_COLUMN_VISIBLE_CUSTOMER_INVOICE,
  field,
  value,
});

// Tạo Khách hàng
export const createAccountBank = data => ({
  type: CREATE_ACCOUNT_BANK,
  data,
});

export const createAccountBankSuccess = data => ({
  type: CREATE_ACCOUNT_BANK_SUCCESS,
  data,
});

export const createAccountBankFail = error => ({
  type: CREATE_ACCOUNT_BANK_FAIL,
  error,
});
export const resetCreateAccountBank = error => ({
  type: RESET_CREATE_ACCOUNT_BANK,
});
